import React from "react";
import ReactDOM from "react-dom/client";
import { createLogger, initLogLevelFromEnvironment } from "./core/logger";
import { App } from "./ui/App";
import "./ui/styles.css";

initLogLevelFromEnvironment(window.location.search, window.localStorage);

const log = createLogger("app");

window.onerror = (message, source, lineno, colno, error) => {
  log.error("uncaught error", {
    message: String(message),
    source,
    lineno,
    colno,
    stack: error?.stack,
  });
};

window.onunhandledrejection = (event: PromiseRejectionEvent) => {
  const reason = event.reason as unknown;
  log.error("unhandled rejection", {
    message: reason instanceof Error ? reason.message : String(reason),
    stack: reason instanceof Error ? reason.stack : undefined,
  });
};

log.info("boot", {
  href: window.location.href,
  referrer: document.referrer || "(none)",
  parentOrigin:
    "ancestorOrigins" in window.location
      ? window.location.ancestorOrigins[0] ?? "(no ancestor)"
      : "(no ancestor)",
  inIframe: window.parent !== window,
  userAgent: navigator.userAgent,
  logLevel: window.location.search,
});

const rootElement = document.getElementById("root");
if (rootElement === null) {
  log.error("root element missing; cannot mount");
} else {
  try {
    ReactDOM.createRoot(rootElement).render(
      <React.StrictMode>
        <App />
      </React.StrictMode>,
    );
    log.info("react mounted");
  } catch (e) {
    const err = e instanceof Error ? e : new Error(String(e));
    log.error("react mount failed", { message: err.message, stack: err.stack });
  }
}
